<template>
  <div class="usage-item-panel">
    <div class="usage-item-panel__title">
      <span>{{ title }}</span>
      <slot name="tooltip" />
    </div>
    <div class="usage-item-panel__value">
      <p v-if="disabled" class="coming-soon">
        {{ "charts.errorMessage.comingSoon" | t }}
      </p>
      <div v-else-if="isError" class="error">
        <p>{{ "charts.errorMessage.usageChartsError1" | t }}</p>
        <p>{{ "charts.errorMessage.usageChartsError2" | t }}</p>
        <button class="button reload-button" @click="$emit('reload')">
          {{ "charts.errorMessage.reload" | t }}
        </button>
      </div>
      <div v-else class="value is-pulled-right">
        {{ value }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
    },
    isError: {
      type: Boolean,
    },
  },
};
</script>

<style scoped lang="scss">
.usage-item-panel {
  height: 72px;

  .usage-item-panel__title {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
  }

  .usage-item-panel__value {
    height: 50px;

    .value {
      font-weight: 900;
      font-size: 28px;
    }

    .coming-soon {
      color: #c8c8c8;
      font-size: 16px;
      text-align: center;
    }

    .error {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 9px;
      text-align: center;

      .reload-button {
        width: 80px;
        height: 22px;
        color: black;
        font-size: 10px;
      }
    }
  }
}
</style>
